import { render, staticRenderFns } from "./form-partners.vue?vue&type=template&id=0082969d&scoped=true"
import script from "./form-partners.vue?vue&type=script&lang=js"
export * from "./form-partners.vue?vue&type=script&lang=js"
import style0 from "./form-partners.vue?vue&type=style&index=0&id=0082969d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0082969d",
  null
  
)

export default component.exports